import { SensorStatus } from '../types/SensorStatus';

export const sensorStatusColors: Record<SensorStatus, string> = {
  OUT: '#9aa0a6',
  IN: '#0ebc9a',
  // Amber gives "in a meeting" its own identity instead of reading as another
  // shade of the green "present" state.
  MEETING: '#f59e0b',
};
